<template>
    <div class="more-on-this-topic">
        <div class="more-on-this-topic__title">
            {{ $page.props.settings.translations.moreOnThisTopic.title }}
        </div>

        <ul class="more-on-this-topic__list">
            <div
                v-for="page in pages"
                :key="page.id"
                class="more-on-this-topic__item"
            >
                <li class="more-on-this-topic__item-inner">
                    <Link
                        class="more-on-this-topic__item-link"
                        :href="page.url"
                    >
                        {{ page.title }}
                    </Link>
                </li>

                <li
                    v-for="pageChild in page.children"
                    :key="pageChild.id"
                    class="more-on-this-topic__item-child"
                >
                    <Link
                        class="more-on-this-topic__item-child-link"
                        :href="pageChild.url"
                    >
                        {{ pageChild.title }}
                    </Link>
                </li>
            </div>
        </ul>
    </div>
</template>

<script setup>
defineProps({
    pages: {
        type: Array,
        required: false,
        default: () => [],
    },
});
</script>

<style lang="scss" scoped>
@use 'watson-theme-more-on-this-topic';
</style>
